/*
 *
 * ----------------------------------------------- */
jQuery(window).on("load", function () {
  setTimeout(() => {
    $(".home").animate({ opacity: 1 }, 1000);
  }, 1500);
});
